var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('h2',{staticClass:"text-black font-semibold text-2xl py-8 text-center"},[_vm._v("Plätze auswählen")]),_c('div',{staticClass:"border rounded-xl overflow-hidden"},[_c('div',{staticClass:"w-full",staticStyle:{"height":"500px"},attrs:{"id":"chart"}})])])
}]

export { render, staticRenderFns }